export { OrderLoyaltyConfirmationSection } from "./OrderLoyaltyConfirmationSection";
